<template>
    <v-layout justify-center>
        <v-responsive width="100%" height="100%" class="mx-n3 px-3">
            <list-heading title="부품 목록"> </list-heading>

            <mes-materials-filter showsSearch />

            <v-card outlined class="mt-4" style="overflow: hidden">
                <v-data-table v-bind="{ loading, headers, items }" disable-sort disable-pagination hide-default-footer :items-per-page="-1">
                    <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" v-slot:[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
                </v-data-table>
            </v-card>
            <v-pagination :value="page" :length="pageCount" :total-visible="11" class="mt-4 mx-4" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { attrs_input, initDataTableHeaders } from "@/assets/variables";

import ListHeading from "@/components/console/dumb/list-heading.vue";
import MesMaterialsFilter from "@/components/console/mes/mes-materials-filter.vue";

const headers = initDataTableHeaders([
    { value: "index", text: "#", width: +80, align: "right" },
    { value: "ITEM_CLASS", text: "부품분류" },
    { value: "CUST_NAME", text: "공급업체" },
    { value: "ITEM_CODE", text: "부품코드" },
    { value: "ITEM_NAME", text: "부품명" },
    { value: "REMARKS", text: "규격" },
    { value: "INCOMING_QTY", text: "입고량", align: "right", formatterType: "number" },
    { value: "USED_QTY", text: "사용량", align: "right", formatterType: "number" },
    { value: "STOCK_QTY", text: "재고량", align: "right", formatterType: "number" },
    { value: "MONTH_PROPER_STOCK", text: "적정재고(월)", align: "right", formatterType: "number" },
    { value: "WEEK_PROPER_STOCK", text: "적정재고(주)", align: "right", formatterType: "number" },
]);

export default {
    components: {
        ListHeading,
        MesMaterialsFilter,
    },
    data() {
        return {
            materials: [],

            limit: 10,
            summary: { totalCount: 0 },

            loading: false,
            headers,
            attrs_input,
        };
    },
    computed: {
        items() {
            return this.materials.map((item, index) => ({ ...item, index: this.summary.totalCount - (this.page - 1) * this.limit - index }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { query } = this.$route;
            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async init() {
            try {
                this.search();
            } catch (error) {
                console.error(error);
            }
        },

        async search() {
            this.loading = true;
            try {
                let { skip, limit, params } = this;
                var { summary, materials } = await api.console.mes.materials.gets({
                    headers: { skip, limit },
                    params,
                });

                this.materials = materials;
                this.summary = summary;
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .line-height-1-5 {
        line-height: 1.5;
    }
    .max-width-0 {
        max-width: 0;
    }
    .word-break-keep-all {
        word-break: keep-all;
    }
    .white-space-pre-line {
        white-space: pre-line;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .v-pagination button {
        box-shadow: none !important;
        border: thin solid rgba(0, 0, 0, 0.12);
    }
    .v-small-dialog__activator {
        height: 100%;
    }
    .v-small-dialog__activator__content {
        width: 100%;
    }

    th:first-of-type:not(:last-of-type),
    td:first-of-type:not(:last-of-type) {
        border-right: thin solid rgba(0, 0, 0, 0.12);
    }

    .v-data-table__expanded__content {
        box-shadow: none !important;
    }
    .vertical-align-top {
        vertical-align: top !important;
    }

    .v-data-table tr td {
        cursor: pointer !important;
    }
}
</style>
